import React from "react";
import "./TableScroll.css";

export default function TableScroll({ children, className = "", minWidth = "100%" }) {
  return (
    <div className={`ts-wrap ${className}`}>
      <div className="ts-scroll">
        <div className="ts-inner" style={{ minWidth }}>
          {children}
        </div>
      </div>
    </div>
  );
}
